import {storeProduct, updateProduct} from "../api/products";
import {getBread} from "../api/bread";
import {upload, copy, uploadPreviewPhotos, uploadAndChangeDPI} from "../api/upload";
import {getColorByName} from "../helpers";

export default {
    data:() => {
        return {
            product:{},
            places:['front', 'back'],
            clothSizes: ['XS','S','SM','M','MD','L','LG','XL','1XL','XXL','2XL','2X','XXXL','3XL','3X','XXXXL','4XL', '4X','XXXXXL','5XL','5X','XXXXXXL','6XL','6X'],
            variantGeneratedImages: [],
            isMounted: false,
            changed:false,
            imagesCreated: [],
            customPhotos: [],
            user: null,
            newMockupImages: [],
            selectedColor: null,
            imageToCreate: null,
            responseFromProduction: null,
            place: null,
            is_mockup: null,
            displayDialog: false,
            colorsAttached: [],
            productionFile: null,
            showDialog: false
        }
    },
    watch:{
        product:{
            deep: true,
            handler:function (val, oldVal) {
                if(this.isMounted){
                    if(val.additional_desc && oldVal.additional_desc) {
                        this.changed = true;
                    }
                }
            }
        }

    },
    computed:{
        totalPrintAreas(){
            var total = 0;
            for(var index in this.product.production_photos){
                if(this.product.production_photos[index].file) total = total + 1;
            }
            return total;
        },
        smallestSizePrice(){
            let variantPrice = 0;
            if((this.product.smake && this.product.price && this.user) || (this.product.smake && this.product.price == 0 && this.user)){
                variantPrice = this.product.smake.price;
                let sizeOfVariants = this.product.variants.length;
                let sizeOfCreatedVariants = this.product.smake.data.variants.length;
                if(this.product.variants && sizeOfVariants > 0){
                    for(let i=0; i<sizeOfCreatedVariants;i++){
                        if((this.product.smake.data.variants[i].attributes[1].value == 'XS' || this.product.smake.data.variants[i].attributes[1].value == 'S') && this.product.smake.data.variants[i].total){
                            for(let j=0;j<sizeOfVariants;j++){
                                if(this.product.variants[j].attributes[0].value == this.product.smake.data.variants[i].attributes[0].value){
                                    variantPrice = this.product.smake.data.variants[i].total;
                                    i = sizeOfCreatedVariants;
                                    j = sizeOfVariants;
                                }
                            }
                        }
                    }
                } else {
                    let sizeOfVariants = this.product.smake.data.variants.length;
                    for(let i=0; i<sizeOfVariants;i++){
                        if((this.product.smake.data.variants[i].attributes[1].value == 'XS' || this.product.smake.data.variants[i].attributes[1].value == 'S') && this.product.smake.data.variants[i].total){
                            variantPrice = this.product.smake.data.variants[i].total;
                            i = sizeOfVariants;
                        }
                    }
                }
            }
            return variantPrice;
        },
        productPriceDelta(){
            var totalViPrice = 0;
            if((this.product.smake && this.product.price && this.user) || (this.product.smake && this.product.price == 0 && this.user)){
                let variantPrice = this.product.smake.price;
                let sizeOfVariants = this.product.variants.length;
                let sizeOfCreatedVariants = this.product.smake.data.variants.length;
                if(this.product.variants && sizeOfVariants > 0){
                    for(let i=0; i<sizeOfCreatedVariants;i++){
                        if((this.product.smake.data.variants[i].attributes[1].value == 'XS' || this.product.smake.data.variants[i].attributes[1].value == 'S') && this.product.smake.data.variants[i].total){
                            for(let j=0;j<sizeOfVariants;j++){
                                if(this.product.variants[j].attributes[0].value == this.product.smake.data.variants[i].attributes[0].value){
                                    variantPrice = this.product.smake.data.variants[i].total;
                                    i = sizeOfCreatedVariants;
                                    j = sizeOfVariants;
                                }
                            }
                        }
                    }
                } else {
                    let sizeOfVariants = this.product.smake.data.variants.length;
                    for(let i=0; i<sizeOfVariants;i++){
                        if((this.product.smake.data.variants[i].attributes[1].value == 'XS' || this.product.smake.data.variants[i].attributes[1].value == 'S') && this.product.smake.data.variants[i].total){
                            variantPrice = this.product.smake.data.variants[i].total;
                            i = sizeOfVariants;
                        }
                    }
                }

                if(this.product.is_customizable && this.product.is_customizable == 1){
                    totalViPrice= variantPrice + parseFloat(this.product.first_custom_fee);
                } else {
                    if(this.totalPrintAreas == 2 && this.product.smake.print_price_second){
                        totalViPrice = variantPrice + this.product.smake.print_price + this.product.smake.print_price_second;
                    } else {
                        totalViPrice = variantPrice + (this.product.smake.print_price * this.totalPrintAreas);
                    }
                }
                if(this.product.ssm_fees) totalViPrice+=parseFloat(this.product.ssm_fees);
                let priceToReturn = parseFloat(this.product.price)  + parseFloat(totalViPrice)*this.user.production_margin;
                if(this.product.is_customizable && this.product.is_customizable == 1) priceToReturn+= parseFloat(this.product.first_margin_fee);
                return priceToReturn.toFixed(2);
            }else{
                return null;
            }
        },
        smakeVariants(){
            if(!this.product || !this.product.smake || !this.product.smake.data.variants) return null;
            var colors = {};
            this.product.smake.data.variants.forEach(item => {
                var finded = item.attributes.find(x => x.name == 'color');
                if(finded){
                    var size = item.attributes.find(x => x.name == 'size');
                    if(item.images && item.images.length > 0){
                        if(!colors[finded.value]) colors[finded.value] = {sizes:[], color: finded.value, image: item.images[0].image};
                    } else {
                        if(!colors[finded.value]) colors[finded.value] = {sizes:[], color: finded.value, image: null};
                    }

                    if(!colors[finded.value].sizes.find(x => x == size.value)) colors[finded.value].sizes.push(size.value);
                }
            })
            const ordered = Object.keys(colors).sort().reduce(
                (obj, key) => {
                    obj[key] = colors[key];
                    return obj;
                },
                {}
            );
            return ordered;
        }
    },
    methods:{
        findAdditionalVariantImages(color){
            return this.variantGeneratedImages.filter(x => x.color == color).map((item) => {
                return item.photo_uri;
            });
        },
        createMocup(place){
            this.$mocup.start(place).then(res => {
                if(place.place === 'front'){
                    this.product.featured_front_image = res;
                } else if (place.place === 'back') {
                    this.product.featured_back_image = res;
                }
                this.$set(place, 'mocup', res);
                this.product.preview_photos.unshift(res);
                this.imagesCreated.push(res);
            })
        },
        uploadProduction(place, file, is_mocup = false){
            var formData = new FormData();
            formData.append('file', file);
            formData.append('skipOwner', true);
            uploadAndChangeDPI(formData, 'product_production').then(response => {
                this.responseFromProduction = response;
                this.place = place;
                this.is_mockup = is_mocup;
                if(response.dpi.length > 0){
                    this.displayDialog=true;
                } else {
                    this.acceptedNewDPI();
                }

            })
        },
        acceptedNewDPI(){
            this.displayDialog=false;
            let response = this.responseFromProduction;
            if(!this.is_mocup){
                this.$set(this.product.production_photos, this.place, {
                    place: this.place,
                    file: response.dpi[0]
                })
                this.productionFile = response.dpi[0];
                this.createMocup(this.product.production_photos[this.place]);
            }else{
                this.$set(this.product.production_photos[this.place], 'mocup', response.dpi[0]);
            }
        },
        uploadPreviewPhoto(files, place = null){
            uploadPreviewPhotos(files).then(response => {
                response.forEach(res=>{
                    this.product.preview_photos.push(res);
                    this.imagesCreated.push(res);
                })
            })
        },
        copyPhotoToProduction(place, imagePath, path){
            copy({'path': imagePath}, path).then(response => {
                this.$set(this.product.production_photos, place, {
                    place: place,
                    file: response.path
                })
                this.createMocup(this.product.production_photos[place]);
            })
        },
        uploadPhotos(event){
            var formData = new FormData();
            var index = 0;
            formData.append('skipOwner', true);
            for(var i in event.target.files){
                formData.append('files['+index+']', event.target.files[i]);
                index++;
            }
            upload(formData, 'product_photos').then(response => {
                response.data.forEach(item => {
                    this.product.preview_photos.push(item);
                })
            })
        },
        copyPhotos(imagePath){
            copy({'path': imagePath}, 'product_photos').then(response => {
                this.product.preview_photos.push(response.path);
            })
        },
        copyAdditionalPhotos(event){
            var formData = new FormData();
            var index = 0;
            formData.append('skipOwner', true);
            for(var i in event.target.files){
                formData.append('files['+index+']', event.target.files[i]);
                index++;
            }
            upload(formData, 'product_photos').then(response => {
                    if(!this.product.additional_photos){
                        this.$set(this.product,'additional_photos',[]);
                    }
                response.data.forEach(item => {
                    this.product.additional_photos.push(item);
                })
            })
        },
        copySizePreviewPhoto(imagePath){
            copy({'path': imagePath}, 'product_photos').then(response => {
                this.product.sizes_preview = response.path;
            })
        },
        variantSlug(variant){
            var str = '';
            variant.attributes.forEach(item => {
                str = str+item.name+': '+item.value+', ';
            })
            return str;
        },
        saveProduct(){
            return new Promise((resolve, reject) => {
                if(this.product.id){
                    var func = updateProduct(this.product.id, {...this.product, generatedVariants: this.variantGeneratedImages});
                }else{
                    var func = storeProduct({...this.product, generatedVariants: this.variantGeneratedImages});
                }
                func.then(response => {
                    resolve(response);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        setProduct(product){
            let colors = [];
            this.customPhotos = [];
            product.variants.forEach(variant=>{
               if(!colors[variant.attributes[0].value]){
                   colors[variant.attributes[0].value] = 'done';
                   let obj = {
                       'name': variant.attributes[0].value,
                       'custom_photos': variant.custom_photos
                   }
                   this.customPhotos.push(obj);
               }
            });
            this.product = {};
            this.$set(this, 'product', product);
            if(product.product_id){
                getBread('Product', product.product_id, {model_name:'Services/SmakeProduct'}).then(res => {
                    this.$set(this.product, 'smake', res);
                })
            }
        }
    }
}
